<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar motivo' : 'Novo motivo' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
                            Informe os dados do motivo.
                        </p>
                    </div>
                </div>
            </div>
            @if(isLoading) {
            <div class="col-12"><app-loading-box height="200"></app-loading-box></div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="section-title">
                        <mat-icon>edit_note</mat-icon>
                        <span>Dados do motivo</span>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome do motivo</mat-label>
                                <input matInput formControlName="nome" placeholder="Ex.: Preço" required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>Informe o nome do motivo.</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="col-12">
                            <div class="toggle-content">
                                <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo"
                                    color="primary">Ativo</mat-slide-toggle>
                                <span class="info-text">
                                    Motivos inativos deixam de aparecer em novas movimentações, preservando o
                                    histórico.
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>
<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
